import React, { createContext, useContext, useState } from 'react';
import { aFechaISO } from '../lib/calendario';

// Estructura de un turno/bloqueo:
// {
//   id, fecha (YYYY-MM-DD), hora (HH:mm), servicioId, canchaId (opcional), tipo: 'reserva' | 'bloqueo', cliente (opcional)
// }

const BookingContext = createContext();

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [agenda, setAgenda] = useState(() => {
    // `aFechaISO` y no `toISOString()`: este es el caso más claro del bug,
    // porque `new Date()` lleva la hora actual. A UTC-3, a partir de las
    // 21:00 `toISOString` devuelve el día siguiente, así que "hoy" pasaba a
    // ser mañana y los turnos de ejemplo quedaban en el día equivocado.
    const hoy = aFechaISO(new Date());
    return [
      // Ejemplo de turnos ya reservados - usar fechas actuales para testear
      { id: 1, fecha: '2024-12-20', hora: '10:00', servicioId: 'Corte de Cabello', tipo: 'reserva', cliente: { nombre: 'Juan', telefono: '1123456789' } },
      { id: 2, fecha: '2024-12-20', hora: '11:00', servicioId: 'Tinte', tipo: 'reserva', cliente: { nombre: 'María', telefono: '1198765432' } },
      // Turnos para hoy
      { id: 4, fecha: hoy, hora: '10:00', servicioId: 'Corte de Cabello', tipo: 'reserva', cliente: { nombre: 'Ana', telefono: '1122334455' } },
      { id: 5, fecha: hoy, hora: '14:00', servicioId: 'Tinte', tipo: 'reserva', cliente: { nombre: 'Carlos', telefono: '1155667788' } },
      // Ejemplo de bloqueo manual
      { id: 3, fecha: '2024-12-21', hora: '15:00', servicioId: 'Corte de Cabello', tipo: 'bloqueo' }
    ];
  });

  // Agregar una reserva
  const addReserva = (reserva) => {
    const nuevaReserva = { ...reserva, id: Date.now(), tipo: 'reserva' };
    setAgenda(prev => [...prev, nuevaReserva]);
  };

  // Agregar un bloqueo manual
  const addBloqueo = (bloqueo) => {
    setAgenda(prev => ([
      ...prev,
      { ...bloqueo, id: Date.now(), tipo: 'bloqueo' }
    ]));
  };

  // Consultar si un slot está ocupado o bloqueado
  const isSlotOcupado = (fecha, hora, servicioId) => {
    const result = agenda.some(item =>
      item.fecha === fecha &&
      item.hora === hora &&
      item.servicioId === servicioId
    );
    

    
    return result;
  };

  // Obtener todos los turnos/bloqueos de una fecha
  const getAgendaPorFecha = (fecha) => {
    return agenda.filter(item => item.fecha === fecha);
  };

  return (
    <BookingContext.Provider value={{ agenda, addReserva, addBloqueo, isSlotOcupado, getAgendaPorFecha }}>
      {children}
    </BookingContext.Provider>
  );
}; 